import { Currency } from '../../court-pricing/dto/court-pricing-rule.dto';

export class PaymentIntentDto {
  id: string;
  status: PaymentIntentStatus;
  userId: string;
  gameId?: number;
  gameBookingId?: string;
  coachingSessionId?: string;
  coachingSessionBookingId?: string;
  gameJoiningId?: string;
  eventJoiningId?: string;
  courtTemporaryBlockadeId?: string;
  createdAt: string;
  updatedAt: string;
  amount: number;
  currency: Currency;
  isSetupIntentPayment: boolean;
  paidWithWallet: boolean;
  lastChargedAmount?: number;
  paymentMethodType?: string;
}
export class NextorePaymentIntentDto {
  id: string;
  status: PaymentIntentStatus;
  userId: string;
  gameId?: number;
  gameBookingId?: string;
  coachingSessionId?: string;
  coachingSessionBookingId?: string;
  gameJoiningId?: string;
  eventJoiningId?: string;
  courtTemporaryBlockadeId?: string;
  createdAt: string;
  updatedAt: string;
  amount: number;
  currency: Currency;
  isStripe: boolean;
  isNextore: boolean;
  paymentMethodType?: string;
  // Set only when paymentMethodType === 'wallet'. `creditsSpent` is the points
  // actually deducted from the user's wallet; `creditConversionRate` is the
  // historical points-per-currency-unit rate (creditsSpent / amount), so the
  // POS UI can render "37.5 pts (≈ €25.00)" without re-applying the org rate.
  creditsSpent?: number;
  creditConversionRate?: number;
}

export enum PaymentIntentStatus {
  canceled = 'canceled',
  processing = 'processing',
  requires_action = 'requires_action',
  requires_capture = 'requires_capture',
  requires_confirmation = 'requires_confirmation',
  requires_payment_method = 'requires_payment_method',
  succeeded = 'succeeded',
  refunded = 'refunded',
  refunding = 'refunding',
  pay_later = 'pay_later',
}
